// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1xK1Q","title":"FrontImage_title__SInNw"};